/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { arrayOf, shape, func, string } from 'prop-types';
import { Form, Modal, Button } from 'semantic-ui-react';
import { Formik, Field } from 'formik';
import { useSelector } from 'react-redux';
import InputField from 'Modules/Formik/Input/Input';
import { TextAreaField, RadioField, DropdownField } from 'Modules/Formik';

import SearchNotfound from '../SearchNotFound/SearchNotFound';

import validationSchema from './validate';
import styles from './AddMedicineModal.less';
import MedicinePickerField from './MedicinePickerField/MedicinePickerField';

const AddMedicineModal = props => {
  const {
    initialValues,
    templates,
    pharmacyId,
    onCancel,
    onSave,
    onAddNew,
    pharmacy,
    currencySymbol,
    serviceId,
  } = props;
  const [isNotfound, setIsNotFound] = useState(false);
  const resultSearchChange = (results, keyword) => {
    setIsNotFound(keyword && !results?.length);
  };

  const prescription = useSelector(state => state.webChat.prescription);
  const {
    prescriptionConfig: { frequencies, dosageUnits, uoms },
  } = prescription;

  const listUom = Object.keys(uoms);

  const handleMapValue = (name, value, form) => {
    if (name === 'uomUnit' && !form.values.doseUnit && uoms[value][0]) {
      form.setFieldValue('doseUnit', uoms[value][0]);
    }
    if (name === 'doseUnit' && !form.values.uomUnit) {
      const uom = Object.keys(uoms).find(key => uoms[key].includes(value));
      uom && form.setFieldValue('uomUnit', uom);
    }
  };
  return (
    <Modal
      className="medicine-modal"
      open
      size="tiny"
      onClose={() => onCancel()}
      closeOnDimmerClick={false}
      closeIcon>
      <Modal.Header>
        {initialValues.mode === 'edit' ? 'Edit Medicine' : 'Add Medicine'}
      </Modal.Header>
      <Modal.Content>
        <div className={styles.modalConten}>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, actions) => {
              try {
                await onSave(values);
              } finally {
                actions.setSubmitting(false);
              }
            }}>
            {({ handleSubmit, setFieldValue, values, isValid, resetForm }) => (
              <Form
                onSubmit={e => {
                  e.stopPropagation();
                  handleSubmit(e);
                }}>
                <Field
                  label=""
                  name="description"
                  pharmacy={pharmacy}
                  pharmacyId={pharmacyId}
                  component={MedicinePickerField}
                  placeholder="Search medicine"
                  resultSearchChange={resultSearchChange}
                  templates={templates}
                  quantity={values?.quantity}
                  uomArr={listUom?.sort()?.map(item => ({ text: item, value: item, key: item }))}
                  useCustomInstruction={values.useCustomInstruction}
                  uomUnit={values.uomUnit}
                  onChange={handleMapValue}
                  currencySymbol={currencySymbol}
                  serviceId={serviceId}
                />
                {isNotfound && <SearchNotfound />}
                {values?.description && (
                  <>
                    <div className={styles.customMode}>
                      <h4>Instruction</h4>
                      <Field
                        label="Custom mode"
                        toggle
                        name="useCustomInstruction"
                        component={RadioField}
                      />
                    </div>
                    {!values.useCustomInstruction && (
                      <>
                        <div style={{ display: 'flex', columnGap: 12 }}>
                          <div style={{ flex: 1 }}>
                            <Field
                              name="amountPerTime"
                              component={InputField}
                              label="Dosage"
                              placeholder="Enter dosage"
                              type="number"
                            />
                          </div>
                          <div style={{ flex: 1 }}>
                            <Field
                              name="doseUnit"
                              component={DropdownField}
                              options={dosageUnits
                                ?.sort()
                                ?.map(item => ({ text: item, value: item, key: item }))}
                              label="Unit"
                              placeholder="Please select"
                              onChange={handleMapValue}
                            />
                          </div>
                        </div>
                        <div className={styles.rowField}>
                          <Field
                            name="frequency"
                            component={DropdownField}
                            options={frequencies.map(item => ({
                              text: item,
                              value: item,
                              key: item,
                            }))}
                            label="Frequency "
                            placeholder="Please select"
                          />
                        </div>
                      </>
                    )}
                    <div className={styles.rowField}>
                      <Field
                        label={values.useCustomInstruction ? '' : 'Note'}
                        name="note"
                        maxlengthchar={500}
                        component={TextAreaField}
                        placeholder="Note for patient ..."
                      />
                    </div>
                    <div className={styles.templateContainer}>
                      {templates &&
                        templates.map(item => (
                          <div
                            key={item.id}
                            className={styles.templateItem}
                            onClick={() => {
                              const newText = values.note
                                ? `${values.note} ${item.template}`
                                : item.template;
                              setFieldValue('note', newText.slice(0, 500));
                            }}>
                            {item.template}
                          </div>
                        ))}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Button
                        type="button"
                        onClick={() => {
                          if (values?.mode === 'add') {
                            resetForm();
                          } else {
                            setFieldValue('description', '');
                            setFieldValue('doseUnit', '');
                            setFieldValue('uomUnit', '');
                            setFieldValue('quantity', 1);
                            setFieldValue('amountPerTime', '');
                            setFieldValue('note', '');
                            setFieldValue('useCustomInstruction', false);
                          }
                        }}
                        className="no-border">
                        Change Medicine
                      </Button>
                      <div className={styles.actionContainer}>
                        <Button type="submit" className={styles.cancel}>
                          Done
                        </Button>

                        <Button
                          type="button"
                          primary
                          onClick={async e => {
                            await handleSubmit(e);
                            if (isValid) {
                              onAddNew();
                            }
                          }}>
                          Save & Add more
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Content>
    </Modal>
  );
};

AddMedicineModal.propTypes = {
  initialValues: shape({}).isRequired,
  templates: arrayOf(shape({})).isRequired,
  pharmacyId: string.isRequired,
  onCancel: func.isRequired,
  onSave: func.isRequired,
  onAddNew: func.isRequired,
  pharmacy: shape({}),
  currencySymbol: string.isRequired,
  serviceId: string,
};

AddMedicineModal.defaultProps = {
  pharmacy: {},
};

export default AddMedicineModal;
